import React, { useState } from "react";
import { Dialog, DialogContent, DialogContentText } from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import moment from "moment";
import "./company-dashboard-initiative-drawer-view-disposition.scss";
import { OverlayScrollbarsComponent } from "overlayscrollbars-react";

const CompanyDashboardInitiativeDrawerViewDisposition: any = (props: any) => {
  const {
    isOpenViewPopup,
    onCancel,
    dispositionData,
    options,
    initiativeDataPermissions,
  } = props;
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [selectedItem, setSelectedItem] = useState<number | null>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>, item: any) => {
    setAnchorEl(event.currentTarget);
    setSelectedItem(item);
  };
  const handleClose = () => {
    setAnchorEl(null);
    setSelectedItem(null);
  };

  const ITEM_HEIGHT = 48;
  return (
    <Dialog
      open={isOpenViewPopup}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      className={`company-dashboard-initiative-drawer-view-disposition`}
      onClose={(event, reason) => {
        if (reason === "backdropClick") {
          return;
        }
        onCancel();
      }}
    >
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          <div className="company-dashboard-initiative-drawer-disposition">
            <div className="company-dashboard-initiative-drawer-disposition-header">
              <div>Disposition History</div>
              <div className="company-dashboard-initiative-drawer-disposition-header-actions"></div>
            </div>
            <OverlayScrollbarsComponent
              options={{
                scrollbars: {
                  theme: "os-theme-dark",
                  autoHide: "scroll",
                  autoHideDelay: 400,
                },
              }}
              style={{ maxHeight: "500px", overflowY: "auto" }}
            >
              {dispositionData?.map((item: any, index: number) => (
                <div
                  key={index + 1}
                  className="company-dashboard-initiative-drawer-disposition-content-view"
                >
                  <div className="company-dashboard-initiative-drawer-disposition-content-header-action">
                    <div
                      className="company-dashboard-initiative-drawer-disposition-content-header-action-text"
                      style={
                        initiativeDataPermissions
                          ? {}
                          : { justifyContent: "flex-start", gap: "20%" }
                      }
                    >
                      <div className="company-dashboard-initiative-drawer-disposition-content-header-action-text-box">
                        As of: <br />
                        <span>
                          {moment(item?.asOf || new Date()).format(
                            "MM-DD-YYYY",
                          )}
                        </span>
                      </div>
                      <div className="company-dashboard-initiative-drawer-disposition-content-header-action-text-box">
                        Reported By: <br />
                        <span> {item?.openedBy}</span>
                      </div>
                      {initiativeDataPermissions && options.length > 0 && (
                        <div className="company-dashboard-initiative-drawer-disposition-content-header-action-button">
                          <IconButton
                            aria-label="more"
                            id="long-button"
                            aria-controls={open ? "long-menu" : undefined}
                            aria-expanded={open ? "true" : undefined}
                            aria-haspopup="true"
                            onClick={(event) => handleClick(event, item)}
                          >
                            <i
                              className="fa fa-ellipsis-v"
                              aria-hidden="true"
                            />
                          </IconButton>
                          <Menu
                            id="long-menu"
                            anchorEl={anchorEl}
                            open={open}
                            onClose={handleClose}
                            slotProps={{
                              paper: {
                                style: {
                                  maxHeight: ITEM_HEIGHT * 4.5,
                                  boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
                                  borderRadius: 16,
                                  padding: 0,
                                },
                                sx: {
                                  "&.MuiPaper-root": {
                                    padding: "0px !important",
                                    width: "156px",
                                  },
                                },
                              },
                              list: { "aria-labelledby": "long-button" },
                            }}
                            anchorOrigin={{
                              vertical: "bottom",
                              horizontal: "right",
                            }}
                            transformOrigin={{
                              vertical: "top",
                              horizontal: "right",
                            }}
                          >
                            {options.map((option: any) => (
                              <MenuItem
                                key={option.label}
                                onClick={() => {
                                  option.onClick(selectedItem);
                                  handleClose();
                                }}
                                sx={{ padding: "8px 16px !important" }}
                              >
                                <img src={option.icon} alt={option.label} />
                                {option.label}
                              </MenuItem>
                            ))}
                          </Menu>
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="company-dashboard-initiative-drawer-disposition-content-main">
                    <div className="company-dashboard-initiative-drawer-disposition-content-main-text">
                      {item?.description || "-"}
                    </div>
                  </div>
                </div>
              ))}
            </OverlayScrollbarsComponent>
            <div className="company-dashboard-initiative-drawer-disposition-close">
              <div className="company-dashboard-initiative-drawer-disposition-close-text">
                <button
                  className="company-dashboard-initiative-drawer-disposition-close-text-button"
                  onClick={onCancel}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </DialogContentText>
      </DialogContent>
    </Dialog>
  );
};

export default CompanyDashboardInitiativeDrawerViewDisposition;
